import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import theme from 'presentation/styles/theme'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'

interface HelpRequestIndicatorCardProps {
  title: string
  quantity: string
  icon?: React.ReactNode
  color?: keyof typeof theme.ds.colors
  onClick?: () => void
}

export const HelpRequestIndicatorCard = ({
  title,
  quantity,
  icon,
  color,
  onClick
}: HelpRequestIndicatorCardProps) => {
  const handleClick = () => onClick && onClick()

  return (
    <CardNew
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '8px',
        alignItems: 'center',
        minHeight: '80px'
      }}
      shadow="medium"
      radius="xsmall"
      onClick={handleClick}
    >
      <S.PercentWrapper>
        <S.Grid>
          <S.AppendIcon>{icon}</S.AppendIcon>
          <HeadingNew
            as="h5"
            weight="semiBold"
            color="neutral700"
            size="xsmall"
            style={{
              marginRight: 'auto',
              borderLeft: '1px solid #EDEDEF',
              paddingLeft: '8px'
            }}
          >
            {title}
          </HeadingNew>

          <SupportTextNew weight="bold" color={color} size="xlarge">
            {quantity}
          </SupportTextNew>
        </S.Grid>
      </S.PercentWrapper>
    </CardNew>
  )
}
